import { graphql } from '@/gql';
import type { MarkRideAsDoNotChargeMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markRideAsDoNotCharge = async ({ description, rideId, requestId }: MarkRideAsDoNotChargeMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      description,
      rideId,
      requestId,
    },
    mutation: graphql(`
      mutation MarkRideAsDoNotCharge($description: String, $rideId: String, $requestId: String) {
        markRideAsDoNotCharge(description: $description, rideId: $rideId, requestId: $requestId) {
          id
        }
      }
    `),
  });

  return !!response.data?.markRideAsDoNotCharge;
};
